import { DefaultState } from 'store/reducers/types';

export const DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_REQUEST = 'DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_REQUEST';
export const DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_SUCCESS = 'DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_SUCCESS';
export const DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_FAILURE = 'DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_FAILURE';

export type AssignmentReportExcelState = DefaultState;

interface AssignmentReportExcelRequest {
  type: typeof DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_REQUEST;
};

interface AssignmentReportExcelSuccess {
  type: typeof DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_SUCCESS,
}

interface AssignmentReportExcelFailure {
  type: typeof DOWNLOAD_ASSIGNMENT_REPORT_EXCEL_FAILURE;
}

export type AssignmentReportExcelActionTypes = AssignmentReportExcelRequest | AssignmentReportExcelSuccess | AssignmentReportExcelFailure;